var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"loading":_vm.cargando,"loading-text":"","no-data-text":"","hide-default-footer":""},on:{"click:row":_vm.seleccionar}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }